var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"chart-area"}},[_c('apexchart',{ref:"balancechart",attrs:{"options":_vm.chartOptions,"series":_vm.series,"height":"400","type":"area"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }